import { render, staticRenderFns } from "./CallWaiter.vue?vue&type=template&id=154ffa52&scoped=true&"
import script from "./CallWaiter.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CallWaiter.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CallWaiter.vue?vue&type=style&index=0&id=154ffa52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154ffa52",
  null
  
)

export default component.exports